import { ADD_URL } from './Actions';

const initialState = {
  url: null
};

function RootReducer(state = initialState, action) {
  switch(action.type) {
    case ADD_URL:
      return Object.assign({}, state, {
        url: action.url
      });

    default:
      return state;
  };
}

export default RootReducer;